module.exports = __webpack_public_path__ + "static/img/news5.9b658d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news5.jpg
// module id = 3wcW
// module chunks = 1